import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frame,
  frameN,
  setFrameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';
import p5 from 'p5';

export function setup() {
	setupCommon();
}

function sign(v) {
	if (v > 0) return 1;
	else if (v < 0) return -1;
	else return 0;
}

function sdf(v, p) {
	// https://iquilezles.org/articles/distfunctions2d/

	const r = 0.1;
	const d = 0.5;

	const p2 = createVector(abs(p.x), abs(p.y));
	const b = sqrt(r * r - d * d);

	const r1 = p5.Vector.sub(p2, createVector(0, b)).mag() * sign(d);
	const r2 = p5.Vector.sub(p2, createVector(-d, 0)).mag() - r;
	return ((p2.y - b) * d > p2.x * b) ?
		r1 :
		r2;

	return 0.5;
}

function cos2(v2) {
	return createVector(Math.cos(v2.x), Math.cos(v2.y));
}

const ls = '@!_% .~=#.*\,:'
let s = 50;
export function draw() {
	drawCommon();

	background(7);
	const poly = [
		cos2(createVector(0, 2.0).add(0 + 3.40 * frameN)).mult(0.3),
		cos2(createVector(0, 1.5).add(1 + 3.45 * frameN)).mult(0.3),
		cos2(createVector(0, 3.0).add(2 + 3.50 * frameN)).mult(0.3),
		cos2(createVector(0, 2.0).add(3 + 3.55 * frameN)).mult(0.3),
		cos2(createVector(0, 1.0).add(4 + 3.60 * frameN)).mult(0.3),
	];

	s = Math.floor(smoothstep(0, 0.6, frameN) * 40 + 10);
	const c = 1 / s;

	translate(w(0.5), h(0.5));
	noStroke();
	for (let i = s / -2; i < s; i++) {
		stroke(0, 0, 10);
		line(w(-0.5), h(i * c + 0.5 * c), w(0.5), h(i * c + 0.5 * c));
		line(w(i * c + 0.5 * c), h(-0.5), w(i * c + 0.5 * c), h(0.5));

		for (let j = s / -2; j < s; j++) {
			const x = i * c;
			const y = j * c + 0.0025;
			const n = noise(x * 3.1 + 3.3, y * 20 + 9.1, Math.sin(frameN * TAU * 2));
			if (n > 0.65) {
				fill(90, 60, 70);
			} else if (n > 0.6) {
				fill(0, 50, 80);
			} else if (n > 0.5) {
				fill(115, 50, 80);
			} else if (n > 0.3) {
				fill(130, 50, 80);
			} else {
				fill(30, 20, 86);
			}

			const d = sdf(poly, createVector(x, y));
			const idx = Math.floor((Math.sin(d * 5 + frameN * TAU) + 1) * 8) % ls.length;
			text(ls.charAt(idx), w(x), h(y));
		}
	}
	resetMatrix();
}
